/* =======================================================
   SnooozeCo — Global JS Bundle
   Loads on every page
   
   1. Footer tagline rotation (YOUR working code)
   2. Footer Dropdown on Mobile
   3. Global Initializers
======================================================= */

/* ------------------------------------------
    1. Footer Tagline
   ------------------------------------------ */

const SnooozeFooterTagline = (() => {
  function init() {
    const el = document.querySelector('.footer-tagline');
    if (!el) return;

    const raw = el.dataset.taglines?.trim() || "";
    const taglines = raw.split('||').map(t => t.trim()).filter(Boolean);
    if (!taglines.length) return;

    const minDelay = parseFloat(el.dataset.delayMin) * 1000;
    const maxDelay = parseFloat(el.dataset.delayMax) * 1000;

    let index = 0;

    el.textContent = taglines[index];
    el.style.opacity = 1;

    function swapTagline() {
      el.style.opacity = 0;

      setTimeout(() => {
        let next = index;
        while (next === index) {
          next = Math.floor(Math.random() * taglines.length);
        }
        index = next;

        el.textContent = taglines[index];
        el.style.opacity = 1;
      }, 500);
    }

    function scheduleNext() {
      const delay = minDelay + Math.random() * (maxDelay - minDelay);
      setTimeout(() => {
        swapTagline();
        scheduleNext();
      }, delay);
    }

    scheduleNext();
  }

  return { init };
})();

/* ------------------------------------------
   2. Footer Dropdown on Mobile
   ------------------------------------------ */

const SnooozeFooterDropdown = (() => {
  function init() {
    const block = document.querySelector(".footer-block--mobile-collapsible");
    if (!block) return;

    const heading = block.querySelector(".footer-block__heading");
    if (!heading) return;

    // Always attach click listener
    heading.addEventListener("click", () => {
      if (window.innerWidth < 750) {
        block.classList.toggle("open");
      }
    });

    // Reset when resizing back to desktop
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 750) {
        block.classList.remove("open");
      }
    });
  }

  return { init };
})();

/* ------------------------------------------
   Global Initializer
   ------------------------------------------ */

function initGlobals() {
  SnooozeFooterTagline.init();
  SnooozeFooterDropdown.init();
}

document.addEventListener('DOMContentLoaded', initGlobals);
document.addEventListener('shopify:section:load', initGlobals);